import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Observable, Subscription, merge } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanySite } from '../../admin-dashboard/company-sites/company-sites.service';
import {MDCTabBar} from '@material/tab-bar';
export interface Site {
  key: string;
  name: string;
}



export interface FatTopBarLink {
  path: string;
  name: string;
}

export interface FatTopBarSetup {
  title: string;
  links: FatTopBarLink[];
  sites: CompanySite[];
}
/**
 * 
  
  showSites: boolean;
 */

@Component({
  selector: 'app-fat-top-bar-layout',
  templateUrl: './fat-top-bar-layout.component.html',
  styleUrls: ['./fat-top-bar-layout.component.css']
})
export class FatTopBarLayoutComponent implements OnInit, OnDestroy{
  @Input() setupObs: Observable<FatTopBarSetup>;
  @Input() showSitesSelector: boolean;

  lotsOfTabs = new Array(30).fill(0).map((_, index) => `Tab ${index}`);

  
  urlSub: Subscription;
  activeLink;
  siteIdObs: Observable<string>;

  constructor(private router: Router, private route: ActivatedRoute) {
    if (route.children.length > 0) {
      this.urlSub = route.children[0].data.subscribe(data => {
        if (data) this.activeLink = data['tab'];
      })
    }
    
  }

  ngOnInit() {
    this.siteIdObs = this.route.params.pipe(map(param => {
      return param['siteId'];
    }))
  }

  onSelection($event, site) {
    this.router.navigateByUrl('/dashboard/sites/' + site.siteId);
  }

  goToSites() {
    this.router.navigateByUrl('/dashboard/sites')
  }

  onBack(){
    this.router.navigate(['../'],{relativeTo:this.route})
  }
  ngOnDestroy(): void {
    this.urlSub.unsubscribe();
  }

}
